import AutoRefill from 'icons/AutoRefills';
import styled, { css } from 'styled-components';
import {
	media, variables
} from 'styledComponents/utils';

export const Container = styled.div`
  margin-bottom: 20px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const Card = styled.div`
  padding: 20px 0;
  background-color: white;

  .description {
    font-size: .875rem;
  }

  .price {
    font-size: .875rem;

    &.flex {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    .line-through {
      text-decoration: line-through;
      margin-right: 5px;
    }
  }

  .shipmentNote {
    font-family: 'GT-Pressura', sans-serif;
    text-transform: uppercase;
    font-size: .75rem;
    color: ${variables.midGrey};
  }

  & > div {
    padding-left: 25px;
    padding-right: 25px;
  }

  background-color: ${props => props.disabled && 'rgba(216, 216, 216, 0.3)'};
  cursor: ${props => (!props.selected && !props.disabled) && 'pointer'};

  .remove {
    font-size: .75rem;
    color: ${variables.midGrey};
    cursor: pointer;
    padding: 0;
    background-color: transparent;
    border-bottom: 1px solid ${variables.midGrey};
    border-radius: 0;
    &:hover {
      border-bottom: 1px solid ${variables.darkGrey};
      color: ${variables.darkGrey};
    }
  }
  
  .more {
    font-size: .75rem;
    color: ${variables.midGrey};
    cursor: pointer;
    padding: 0;
    background-color: transparent;
    border-bottom: 1px solid ${variables.midGrey};
    border-radius: 0;
    &:hover {
      border-bottom: 1px solid ${variables.darkGrey};
      color: ${variables.darkGrey};
    }
  }
`;

const SingleOptionCard = styled(Card)`
  padding-top: 17px;
  padding-bottom: 17px;
  position: relative;

  & > div {
    display: flex;
    justify-content: space-between;
  }

  .description {
    color: ${variables.midGrey};
  }

  box-shadow: none;
  background-color: ${props => props.selected ? variables.lightYellow : '#ECEBEA'};
`;

const MultipleOptionCard = styled(Card)`
  padding-top: 17px;
  padding-bottom: 17px;
  position: relative;
  margin-bottom: 20px;
  
  padding-bottom: ${props => props.moreOptions && '0px'};

  & > div {
    display: flex;
    justify-content: space-between;
  }

  .description {
    color: ${variables.midGrey};
  }

  box-shadow: none;
  background-color: ${props => props.inCart ? variables.lightYellow : '#ECEBEA'};
`;

const ProductOption = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: .875rem;
  display: flex;
  justify-content: space-between;
  &:hover {
    background-color: ${variables.lightYellow};
    cursor: pointer;
  }

  background-color: ${props => props.selected ? `${variables.lightYellow}` : 'white'};

  .msrp {
    margin-right: 10px;
    color: ${variables.midGrey};
    text-decoration: line-through;
  }
`;

export const DetailsContainer = styled.div`
  display: flex;
  justify-content: flex-start !important;
  align-items: flex-start;
  font-size: .875rem;
  margin-top: 1rem;

  &.refill-details {
    margin-top: 0;
    margin-left: 1rem;
    flex-direction: column;
    align-items: flex-start;

    ${media.tablet`
      flex-direction: row;
      align-items: center;
    `}
  }

  ${media.tablet`
    align-items: center;
    margin-top: 6px;
  `}
`;

export const Chip = styled.div`
  background: ${variables.midGrey};
  color: ${variables.white};
  padding: 1px 16px;
  border-radius: 16px;
  margin-right: 8px;
`;

export const AutoRefillIcon = styled(AutoRefill)`
  height: 26px;
  width: 26px;
  margin-right: 8px;

  g {
    stroke: ${variables.lightMint};
  }
`;

export const AutoRefillContainer = styled.div`
  display: flex;
  justify-content: space-between;
  .autorefill-title {
    line-height: 1.25;
  }

  .flex-start {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    div {
      margin-right: 8px;
    }

    p {
      margin: 0;
      size: 16px;
      &.selected {
        margin-right: 5px;
        font-size: 14px;
      }
    }
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  p {
    margin: 0;
    margin-right: 8px;
    font-weight: bold;
  }
`;

export const AutoRefillDetail = styled.div`
  margin-top: 8px;

  p {
    margin: 0;
    font-size: 14px;
    color: ${variables.midGrey};
    line-height: 1.43;
    text-align: left;
  }
`;

export const AddToCart = styled.div.attrs(({ addPad }) => ({
	marginTop: addPad ? 24 : 8,
}))`
  display: flex;
  justify-content: flex-end !important;
  margin-top: ${props => props.marginTop}px;
  position: relative;
  ${props => props.moreOptions && 'padding-bottom: 15px;'}
  ${props => props.isFlex && css`display: flex; justify-content: space-between !important;`}
  ${props => !props.two && 'justify-content: flex-start !important;'}

  .remove {
    font-size: 14px;
    line-height: 1.43;
  }
  
  .more {
    font-size: 14px;
    line-height: 1.43;
  }
`;

export const TitleAndPrice = styled.div`
  align-items: flex-start;

  .title {
    padding-right: 20px;
  }
`;

export const Price = styled.div`
  font-size: .875rem;

  &.flex {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    ${props => props.alignRight && 'justify-content: flex-end;'}
  }

  .line-through {
    text-decoration: line-through;
    margin-right: 5px;
  }
`;

export const NewCheckoutContainer = styled.div`
  margin-bottom: 20px;
  position: relative;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const NewCheckoutCard = styled.div`
  padding: 20px 0;
  background-color: white;

  .description {
    font-size: 12px;
    margin-top: 5px;
    ${media.tablet`
      font-size: 12px;
    `}
  }

  .description-price {
    text-align: right;
    font-size: 12px;
    margin-top: 0;
    width: max-content;
    color: #000000;
    ${media.tablet`
      font-size: 12px;
    `}
  }

  .price {
    font-size: 14px;

    &.flex {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    .line-through {
      text-decoration: line-through;
      margin-right: 5px;
      color: #8B8A87;
    }
  }

  .shipmentNote {
    ${media.smallMobile`
      margin-left: -13px;
      font-size: 10px;
      position: absolute;
      bottom: -35px;
    `}
    margin-left: -11px;
    position: relative;
    font-family: 'GT-Pressura', sans-serif;
    text-transform: uppercase;
    font-size: .75rem;
    color: ${variables.midGrey};
  }


  background-color: ${props => props.disabled && 'rgba(216, 216, 216, 0.3)'};
  cursor: ${props => (!props.selected && !props.disabled) && 'pointer'};
  
  .more {
    font-size: .75rem;
    color: ${variables.midGrey};
    cursor: pointer;
    padding: 0;
    background-color: transparent;
    border-bottom: 1px solid ${variables.midGrey};
    border-radius: 0;
    &:hover {
      border-bottom: 1px solid ${variables.darkGrey};
      color: ${variables.darkGrey};
    }
  }
`;

const NewCheckoutSingleOptionCard = styled(NewCheckoutCard)`
  padding-top: 15px;
  min-height: 135px;
  padding-bottom: 17px;
  position: relative;
  margin: 0 auto;
  display: flex;
  flex-direction: row;

  ${media.desktop`
    max-width: 705px;
    margin-top: 34px;
  `}

  & > div {
    display: flex;
    justify-content: space-between;
  }

  .description {
    color: ${variables.midGrey};
  }

  box-shadow: none;
  background-color: white;
`;

const NewCheckoutMultipleOptionCard = styled(NewCheckoutCard)`
  padding-top: 25px;
  min-height: 110px;
  padding-bottom: 17px;
  position: relative;
  margin: 0 auto;

  ${media.tablet`
    max-width: 568px;
    max-height: 170px;
  `}

  ${media.desktop`
    max-width: 705px;
  `}

  & > div {
    display: flex;
    justify-content: space-between;
  }

  .description {
    color: ${variables.midGrey};
  }

  box-shadow: none;
`;

const NewCheckoutProductOption = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: .875rem;
  display: flex;
  justify-content: space-between;
  &:hover {
    background-color: ${variables.lightYellow};
    cursor: pointer;
  }

  background-color: ${props => props.selected ? `${variables.lightYellow}` : 'white'};

  .msrp {
    margin-right: 10px;
    color: ${variables.midGrey};
    text-decoration: line-through;
  }
`;

export const NewCheckoutDetailsContainer = styled.div`
  display: flex;
  justify-content: flex-start !important;
  align-items: flex-start;
  font-size: .875rem;
  margin-top: 1rem;

  &.refill-details {
    margin-top: 0;
    margin-left: 1rem;
    flex-direction: column;
    align-items: flex-start;

    ${media.tablet`
      flex-direction: row;
      align-items: center;
    `}
  }

  ${media.tablet`
    align-items: center;
    margin-top: 6px;
  `}
`;

export const NewCheckoutChip = styled.div`
  background: ${variables.midGrey};
  color: ${variables.white};
  padding: 1px 16px;
  border-radius: 16px;
  margin-right: 8px;
`;

export const NewCheckoutAutoRefillIcon = styled(AutoRefill)`
  height: 26px;
  width: 26px;
  margin-right: 8px;

  g {
    stroke: ${variables.lightMint};
  }
`;

export const NewCheckoutAutoRefillContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
  height: 32px;
  padding: 6px 17px 6px 6px;
  border-radius: 2px;

  .slider {
    margin-right: 5px;
  }

  .autorefill-title {
    line-height: 1.25;
  }

  .flex-start {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    div {
      margin-right: 8px;
    }

    p {
      font-size: 12px !important;
      font-weight: normal !important;
      margin: 0;
    }
  }

	.ar-detail-checkbox {
		&:focus-visible { 
			outline: 3px dashed !important;
		}
	}
`;

export const NewCheckoutToggleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  p {
    font-size: 14px !important;
    font-weight: 400;
		line-height: 20px;
    ${({ disabled }) => disabled && `
      color: #999999;
    `}

		${media.tablet`
			font-size: 16px !important;
			line-height: 24px;
		`}
  }
`;

export const NewCheckoutAutoRefillDetail = styled.div`
  padding: 0 0 0 27px;
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  ${media.tablet`
    flex-direction: row;
    justify-content: flex-end !important;
    align-items: flex-end;  
  `}

  ${props => props.oral && 'width: 151px; top: 132px;'}

  ${media.desktop`
    max-width: 378px;
  `}

  p {
    color: ${({ theme }) => theme.neutrals[500]};
    font-size: 10px;
    font-style: italic;
    line-height: 14px;
    max-width: 220px;
    ${media.tablet`
      max-width: 300px;
			font-size: 12px;
			line-height: 16px;
			padding-right: 10px;
    `}
  }
`;

export const NewCheckoutAddToCart = styled.div.attrs(({ addPad }) => ({ marginTop: addPad ? 24 : 8 }))`
  display: flex;
  justify-content: flex-end !important;
  margin-top: ${props => props.marginTop}px;
  ${props => props.moreOptions && 'padding-bottom: 15px;'}
  ${props => props.isFlex && css`
    display: flex;
    justify-content: space-between !important;
  `}
  ${props => !props.two && 'justify-content: flex-start !important;'}

  .remove {
    font-size: 14px;
    line-height: 1.43;
  }
  
  .more {
    font-size: 14px;
    line-height: 1.43;
  }
`;

export const NewCheckoutTitleAndPrice = styled.div`
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  flex-direction: column;

  padding: 0 !important;
  .title {
    padding-right: 20px;
    line-height: 1.2;
    ${media.tablet`
      font-size: 15px;
      max-width: 491px;
      margin-left: 0;
      font-size: 16px;
    `}
  }

  .product-title {
    margin-bottom: 8px;
  }

  .rx-label {
    font-size: 8px;
    vertical-align: 50%;
  }
`;

const ProductWrapper = styled.div`
  background-color: white;
  position: relative;
  z-index: 5;
  padding: 56px 24px 0; 
  height: max-content;
  margin-top: 15px;
  width: 100%;
  box-shadow: 0 2px 4px rgba(51, 51, 51, 0.08);
  ${props => props.currentRXKit && css`
    padding: 18px;
    margin-top: 0px;
  `};
  ${media.tablet`
    max-width: 568px;  
    margin-top: 20px;
  `}

  ${media.desktop`
    max-width: 800px;
    margin-right: 40px;
    margin-top: 40px;
    padding: 40px;
  `}

  h2 {
    letter-spacing: 0;
    font-size: 22px;
    margin-top: 0px;
    margin-bottom: 10px;
    ${media.tablet`
      font-size: 32px;
    `}
  }
  hr {
    margin-bottom: 0;
    ${media.tablet`
      margin-bottom: 20px;
    `}
  }

	.checkout-header {
		font-size: 24px;
		font-family: Maax;
		font-style: italic;
		font-weight: 500;
		line-height: 32px;
		letter-spacing: -0.1px;

		${media.tablet`
			font-size: 32px;
			line-height: 40px;
		`}
	}
`;

const BetterTogether = styled.div`
  background-color: rgba(149, 207, 196, 0.17);
  padding: 15px;
  display: flex;
  justify-content: center;
  margin: 0 auto;

  ${media.tablet`
    text-align: center;
    max-width: 528px;  
  `}

  ${media.desktop`
    max-width: 705px;
  `}

  h1 {
    font-size: 18px;
    max-width: 300px;
    ${media.tablet`
      font-size: 20px;
      max-width: 425px;
    `}
    ${media.desktop`
      max-width: 600px;
    `}
  }
  p {
    font-size: 12px;
    max-width: 300px;
    margin-bottom: 0;
    margin-top: -5px;
    ${media.tablet`
      max-width: 425px;  
    `}
    ${media.desktop`
      max-width: 600px;
    `}
  }
`;

const SaveTenWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  ${media.tablet`
    justify-content: center;
  `}
`;

const SaveTen = styled.div`
  width: 85px;
  height: 30px;
  margin: 0 0 0 10px;
  padding: 6px;
  ${media.smallMobile`
    padding-left: 4px;
    font-size: .7em;
    width: 110px;
  `}
  padding-right: 0;
  border-radius: 2px;
  background-color: #80cfc2;
  color: white;
  font-size: 13px;
`;

const ThumbnailWrapper = styled.div`
  height: 58px;
  width: 50px;
  min-width: 50px;
  position: relative;
  margin-right: 8px;
  ${props => props.type === 'topical' && 'background-image: url(https://assets.apostrophe.com/img/newCheckout/topical-product-update.png);'}
  ${props => props.type === 'oral' && css`
    background-image: url('https://assets.apostrophe.com/img/newCheckout/oral-product-update.png');
    background-position-x: -5px;
  `}
  ${props => props.type === 'sunscreen' && 'background-image: url(https://assets.apostrophe.com/img/OTCs/RET1_Apostrophe+June-2021.jpg);'}
  ${props => props.type === 'body' && css`
    background-image: url('https://assets.apostrophe.com/img/newCheckout/body-product.png');
    background-position-y: -3px;
  `}
  background-size: cover;
  background-repeat: no-repeat;

  ${media.tablet`
    display: none;
  `}
`;

export const ThumbnailWrapperDesktop = styled.div`
  display: none;
  ${media.tablet`
    display: block;
  `}
  margin-right: 20px;
  margin-top: 11px;
  height: 123px;
  width: 134px;
  min-width: 134px;
  position: relative;
  ${props => props.type === 'topical' && `background-image: url(https://assets.apostrophe.com/img/newCheckout/topical-product-update.png);
    background-position-y: -9px;
  `}
  ${props => props.type === 'oral' && css`
    background-image: url('https://assets.apostrophe.com/img/newCheckout/oral-product-update.png');
    background-position-x: -5px;
  `}
  ${props => props.type === 'sunscreen' && 'background-image: url(https://assets.apostrophe.com/img/OTCs/RET1_Apostrophe+June-2021.jpg);'}
  ${props => props.type === 'body' && css`
    background-image: url('https://assets.apostrophe.com/img/newCheckout/body-product.png');
    background-position-y: -9px;
  `}
  background-size: contain;
  background-repeat: no-repeat;
`;

const NewCheckoutPrice = styled.div`
  font-size: 14px;
  justify-content: flex-start;
  ${media.tablet`
    font-size: 16px;
  `}

  &.flex {
    display: flex;
    align-items: center;
  }

  ${media.tablet`
    justify-content: flex-end;
  `}

  .line-through {
    text-decoration: line-through;
    margin-right: 5px;
  }
`;

const ProductOptionsSelect = styled.div`
  display: flex;
  width: 100%;
  margin-top: 24px;
  justify-content: space-between;
	align-items: center;
  padding: 0 !important;
	border-radius: 4px;
	border: solid 1px #E1E2E2;
  ${media.tablet`
    top: 96px;
    ${props => props.oral && 'top: 120px;'}
		max-width: 285px;
  `}

	div {
		display: flex;
		flex-direction: column;
		width: 100%
	}

  p {
    font-size: 12px;
    color: #000000;
    margin-top: 7px;
		${media.tablet`
			font-size: 16px;
			line-height: 24px;
		`}
  }

  select {
    width: 100%;
    height: 30px;
    padding: 0 0 0 15px;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
		border: none;
		${media.tablet`
			font-size: 16px;
			line-height: 24px;
		`}
  }
  .option {
    background-color: pink;
  }

	.option-sub-text {
		color: ${({ theme }) => theme.colors.teal.dark};
		font-size: 10px;
		font-style: italic;
		line-height: 16px;
		padding: 0 0 5px 15px;
		margin-top: 0;
		${media.tablet`
			font-size: 12px;
			line-height: 16px;
		`}
	}

	svg {
		padding-right: 5px;
	}
`;

const ImageTitleWrapper = styled.div`
  ${media.smallMobile`
    width: 73%;
  `}
  width: 215px;

  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
`;

const Barrier = styled.div`
  position: relative;
  z-index: 10;
  width: 400px;
  margin-left: -20px;
  height: 20px;
  ${props => props.RXKit && css`
    margin-left: -32px;
  `};
  ${media.tablet`
    width: 586px;
    margin-left: -20px;
  `}
  ${media.desktop`
    width: 803px;
    margin-left: -40px;
    height: 40px;
  `}
`;

export const RXBanner = styled.div`
  background-color: #000000;
  width: 28px;
  height: 21px;
  color: white;
  font-size: 11px;
  line-height: 12px;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  ${media.desktop`
    top: 10px;
  `}
`;

export const InfoIcon = styled.span`
  width: 16px;
  height: 16px;
  min-width: 16px;
  margin-right: 5.33px;
  ${media.tablet`
    margin-right: 0;
    margin-left: 5.33px;  
    margin-top: 3px;
  `}
  border: 1px solid #000000 !important;
  border-radius: 8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  color: #000000;
  cursor: pointer;
  font-size: 10px;
`;

export const InfoBox = styled.div`
  width: 275px;
  position: absolute;
  right: 0px;
  height: auto;
  background-color: white;
  color: #000000;
  padding: 24px;
  z-index: 100;
  top: 160px;
  border: 1px solid rgba(230, 230, 230) !important;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  ${media.tablet`
    margin-top: 0;
  `}

  ${props => props.isMobile && css`
    width: 100vw;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    height: fit-content;
    padding: 48px 32px 32px 32px;
  `};
  
  h5 {
    position: absolute;
    top: -27px;
    right: -7px;
    color: #000000;
    font-size: 12px;
    cursor: pointer;
  }
  .info-box-title {
    margin-bottom: 4px;
    font-style: italic;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: -0.002em;
  }

  .info-box-description {
    margin-bottom: 16px;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.1px;
  }
`;

export {
	Barrier,
	BetterTogether,
	ImageTitleWrapper,
	MultipleOptionCard,
	NewCheckoutMultipleOptionCard,
	NewCheckoutPrice,
	NewCheckoutProductOption,
	NewCheckoutSingleOptionCard,
	ProductOption,
	ProductOptionsSelect,
	ProductWrapper,
	SaveTen,
	SaveTenWrapper,
	SingleOptionCard,
	ThumbnailWrapper,
}

export const StatusTag = styled.div`
  
  @font-face {
    font-family: 'GT-Pressura-Mono';
    font-style: normal;
    src: url('https://assets.apostrophe.com/fonts/GT-Pressura-Mono/regular.woff2') format('woff2'),
        url('https://assets.apostrophe.com/fonts/GT-Pressura-Mono/regular.woff') format('woff');
  }

  padding: 3px 7px;
  margin-bottom: 6px;
  background-color: ${({ theme }) => theme.colors.teal.light};
  width: fit-content;
  border-radius: 5px;
  font-family: 'GT-Pressura-Mono';
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: -0.20000000298023224px;
  text-align: left;
  
  color: #000000;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  
  ${media.tablet`
    font-size: 14px;
    line-height: 16px;
  `}
  ${({ fontSize }) => `
    font-size: ${fontSize}px !important;
    line-height: 12px;
  `}
`;

export const ARDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
	justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  ${media.tablet`
    align-items: center;
  `}

	.question-icon-wrapper {
		padding-right: 10px;
		&:focus-visible { 
			outline: 3px dashed !important;
		}
	}
`;

export const PricingWrapperDesktop = styled.div`
  display: none;
  ${media.tablet`
    display: flex;
    flex-direction: row;

		.remove-icon {
			&:focus-visible { 
				outline: 3px dashed !important;
			}
		}
  `}
`;

export const PricingWrapperMobile = styled.div`
  width: 100%;  
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .remove-icon {
    margin-top: 16px;
		&:focus-visible { 
			outline: 3px dashed !important;
		}
  }

  ${media.tablet`
    display: none;
  `}
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 14px;
  width: 100%;
  ${media.tablet`
    flex-direction: row;
    height: max-content;
  `}
`;

export const PrimaryInfoContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
	width: 100%;
  ${media.tablet`
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    align-items: flex-start;
  `}
`;

export const ARModal = styled.div`
  right: -110px
  height: 59px;
  width: 235px;
  ${media.tablet`
    right: 0;
  `}
  top: 34px;
  border-radius: 4px;
  position: absolute;
  z-index: 100;
  background-color: white;
  box-shadow: 0px 2px 6px 0px #00000047;
  padding: 16px 16px 16px 24px;
  color: #000000;
  font-family: Maax;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: -0.002em;
  text-align: left;

`;

export const Cancel = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  ${({ top }) => top && `
    top: ${top}px;
  `}
  ${({ right }) => right && `
    right: ${right}px;
  `}
  bottom: 0;
  background-image: url('/static/img/apostrophe/icons/close.svg');
  height: 8px;
  width: 8px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
`;

export const InfoAndThumbnailWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const PricingContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: flex-start;
  margin-top: 16px;
  margin-right: 21px;
  ${media.tablet`
    margin-top: 0px;
    align-items: flex-end;
  `}
`;

export const InfoModal = styled.div`
	.info-box-title {
    margin-bottom: 4px;
    font-style: italic;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    letter-spacing: -0.002em;
  }

  .info-box-description {
    margin-bottom: 16px;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.1px;
  }
`;

export const ARDetailsTextContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 10px 0 10px 10px;
`;

export const ARDetailsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	border: 1px solid ${({ theme }) => theme.neutrals[300]};
	border-radius: 4px;
	margin-top: 24px;

	${media.tablet`
		margin-top: 11px;
	`}
`;

export const ARDetailsSubTitle = styled.div`
	display: flex;
	flex-direction: row;
	padding: 10px 10px 10px 16px;
	background-color: rgba(225, 243, 240, 0.3);
	align-items: center;

	p {
		padding-left: 5px;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
	}
`;
